import sharedModule from '../shared.module';
import template from './asMultiSelect.template.html';
import style from './asMultiSelect.template.scss';
import $ from 'jquery';

sharedModule.directive('asMultiselect', function() {
    return {
        restrict: 'EA',
        scope: {
            items: '=',
            placeholder: '@',
            validation: '=?',
            options: '=?',
            ngModel: '=',
            onChange: '&'
        },
        template,
        style,
        link: function(scope, element) {
            element.on('$destroy', function() {
                scope.destroy();
            });
            scope.$watch('options', scope.onOptionsUpdate, true);
            scope.$watch('ngModel', scope.onModelUpdate, true);
            scope.$watch('items', scope.onItemsUpdated, true);
            scope.$watch('placeholder', scope.onPlaceholderUpdated, true);
        },
        controller: [
            '$scope',
            '$element',
            '$timeout',
            function($scope, $element) {
                var selectElem = null;
                var isShown = false;

                $scope.destroy = function() {
                    clearSelectpicker();
                };

                function clearSelectpicker() {
                    if (selectElem) {
                        selectElem.selectpicker('destroy');
                        selectElem = null;
                    }
                }

                $scope.onPlaceholderUpdated = function() {
                    if (selectElem) {
                        selectElem.attr({ title: $scope.placeholder });
                        selectElem.selectpicker('destroy');
                        initSelectpicker();
                        if (isShown) {
                            selectElem.selectpicker('toggle');
                        }
                    }
                };

                function initSelectpicker() {
                    // init select picker
                    selectElem.selectpicker(
                        $scope.options ? $scope.options : {}
                    );
                    selectElem.on('shown.bs.select', onSelectShown);
                    selectElem.on('hidden.bs.select', onSelectHidden);
                    selectElem.selectpicker('val', $scope.ngModel);
                }

                $scope.onItemsUpdated = function() {
                    clearSelectpicker();
                    if ($scope.items && $scope.items.length > 0) {
                        selectElem = $($element.find('.selectpicker'));
                        var htmlArray = [];
                        var optGroups = {};
                        $scope.items.forEach(function(item) {
                            if (!optGroups[item.optgroup]) {
                                optGroups[item.optgroup] = [item];
                            } else {
                                optGroups[item.optgroup].push(item);
                            }
                        });

                        for (var key in optGroups) {
                            var group = optGroups[key];
                            if (key != 'undefined') {
                                htmlArray.push(
                                    '<optgroup label="' + key + '">'
                                );
                            }
                            group.forEach(function(item) {
                                htmlArray.push('<option value="');
                                htmlArray.push(item.value);
                                htmlArray.push('"');
                                if (item.icon) {
                                    htmlArray.push(
                                        ' data-content="' +
                                            item.icon +
                                            ' ' +
                                            item.label +
                                            '"'
                                    );
                                }
                                if (item.disabled) {
                                    htmlArray.push(' disabled');
                                }
                                htmlArray.push('>');
                                htmlArray.push(item.label);
                                htmlArray.push('</option>');
                            });
                            if (key != 'undefined') {
                                htmlArray.push('</optgroup>');
                            }
                        }
                        var html = htmlArray.join('');
                        selectElem.html(html);

                        initSelectpicker();
                    }
                    validateMaxSelection();
                };

                function onSelectShown() {
                    isShown = true;
                }

                function onSelectHidden() {
                    isShown = false;
                }

                $scope.onOptionsUpdate = function() {
                    if ($scope.options && $scope.options.disabled != null) {
                        selectElem.prop('disabled', $scope.options.disabled);
                    }
                };

                $scope.onModelUpdate = function() {
                    if (selectElem) {
                        selectElem.selectpicker('refresh');
                    }
                };

                $scope.onSelectChange = function() {
                    $scope.error = null;
                    validateRequired();
                    $scope.onChange({ value: $scope.ngModel });
                };

                function validateMaxSelection() {
                    if (
                        $scope.options &&
                        $scope.options.maxSelection &&
                        $scope.ngModel &&
                        $scope.ngModel.length > $scope.options.maxSelection
                    ) {
                        $scope.ngModel.splice($scope.options.maxSelection);
                    }
                }

                function validateRequired() {
                    if ($scope.validation && $scope.validation.required) {
                        if (!$scope.ngModel || $scope.ngModel.length === 0) {
                            $scope.error = 'This field is required';
                        }
                    }
                }
            }
        ]
    };
});



// WEBPACK FOOTER //
// ./modules/shared/asMultiSelect/asMultiSelect.directive.js